import { render, staticRenderFns } from "./GeradorDeBorderRadius.vue?vue&type=template&id=7e4e1289&"
import script from "./GeradorDeBorderRadius.vue?vue&type=script&lang=js&"
export * from "./GeradorDeBorderRadius.vue?vue&type=script&lang=js&"
import style0 from "./GeradorDeBorderRadius.vue?vue&type=style&index=0&lang=scss&scooped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports